import { includesInLC } from "@datassential/platform-ui-lib";

export interface iGlobalUserData {
    hasFFChainsEnableLoginPermission: boolean;
    hasFFChainsFeaturePermission: boolean;
    hasMacAdminAccess: boolean;
}

export default class GlobalUserData implements iGlobalUserData{
    hasFFChainsEnableLoginPermission= false;
    hasFFChainsFeaturePermission: boolean = false;
    hasMacAdminAccess: boolean = false;

    constructor(pageData?: Window['pageData'] | null) {
        if (pageData) {
            this.hasFFChainsEnableLoginPermission = pageData?.hasSnapFeaturesProduct || false;
            this.hasFFChainsFeaturePermission = pageData?.hasSnapFeaturesFfChains || false;
            this.hasMacAdminAccess = pageData.headerUserActionsMenuItems.some(
                i => includesInLC(i.title, 'mac')
            ) || false;
        }
    }
}